import type { TextSizingConfigs } from './utils';
import { devices } from '../common/devices';
import { colors, darkThemeSelector, styled } from '../stitches.config';
import { Text } from './Text';

const headingVars = {
  touch: {
    size: 24,
    lineHeight: 32,
  },
  mouse: {
    size: 20,
    lineHeight: 28,
  },
} as const satisfies TextSizingConfigs;

const HeadingBase = {
  color: colors.headingNeutralLight,
  [darkThemeSelector]: {
    color: colors.headingNeutralDark,
  },
  variants: {
    internal: {
      true: {
        color: colors.internalBodyLight,
        [darkThemeSelector]: {
          color: colors.internalBodyDark,
        },
      },
      false: {},
    },
  },
};

export const HeadingSansSizes = {
  '&': {
    [devices.touch]: {
      fontSize: `$${headingVars.touch.size}`,
      lineHeight: `$${headingVars.touch.lineHeight}`,
    },
    [devices.mouse]: {
      fontSize: `$${headingVars.mouse.size}`,
      lineHeight: `$${headingVars.mouse.lineHeight}`,
    },
  },
};

export const HeadingMonoSizes = {
  '&': {
    [devices.touch]: {
      fontSize: `$${headingVars.touch.size - 1}`,
      lineHeight: `$${headingVars.touch.lineHeight}`,
    },

    [devices.mouse]: {
      fontSize: `$${headingVars.mouse.size - 1}`,
      lineHeight: `$${headingVars.mouse.lineHeight}`,
    },
  },
};

export const Heading = styled(Text, HeadingBase, {
  variants: {
    context: {
      body: {},
      heading: {},
    },
    family: {
      regular: HeadingSansSizes,
      monospace: HeadingMonoSizes,
    },
    weight: {
      medium: {},
    },
  },
  defaultVariants: {
    context: 'heading',
    family: 'regular',
    weight: 'bold',
  },
});
Heading.displayName = 'Heading';
